module.exports = {
  en: require("./en"),
  fa: require("./fa"),
};
